import {handleResponse} from "./handleResponse";
import {IPortDetails} from "../interfaces/INauticalLocation";
import {createHttpGetOptions} from "./request.util";

export const fetchPorts = (authToken: string): Promise<IPortDetails[]> => {
    const url = '/ports'
    const options = createHttpGetOptions(authToken);
    return fetch(url, options).then(handleResponse)
}